
export class StockAvailabilityDto {
    all: number = 0;
    active: number = 0;
    inactive: number = 0;
}
